/**
 * Getting-started checklist — query hook.
 *
 * Backed by internal/tenant/onboarding.Handler.Mount, exposed as
 * GET /api/v1/tenants/{tenant_id}/getting-started under
 * the platform-admin gate (WithPathTenant supplies the tenant).
 */

import { useQuery } from "@tanstack/react-query";
import { apiFetch, type ApiError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import { setupStatusSchema, type SetupStatus } from "./schemas";

export async function fetchSetupStatus(tenantID: string): Promise<SetupStatus> {
  const raw = await apiFetch<unknown>(
    `/api/v1/tenants/${encodeURIComponent(tenantID)}/getting-started`,
  );
  return setupStatusSchema.parse(raw);
}

export function useSetupStatusQuery(tenantID: string) {
  return useQuery<SetupStatus, ApiError>({
    queryKey: queryKeys.gettingStarted(tenantID),
    queryFn: () => fetchSetupStatus(tenantID),
    enabled: tenantID.length > 0,
    staleTime: 30_000,
  });
}
